module.exports = require("skypager-util/lib/string");


//////////////////
// WEBPACK FOOTER
// external "skypager-util/lib/string"
// module id = 15
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 14